import React from "react";
import {useEffect} from "react";
import {useState} from "react";
import {useNavigate} from "react-router";
import {AESEncryption, ApiResDecrypt} from "../../../CommonMethhods/CommonMethods";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function ClientDetailsOmsComp(props) {
    const {URL, mainType} = props;
    const storeToken = localStorage.getItem("ssoToken");
    if (storeToken == null) {
        window.location.replace("/");
    }
    const navigate = useNavigate();
    const [clientData, setClientData] = useState();
    useEffect(() => {
        if (!localStorage.getItem("panNo") || localStorage.getItem("panNo") === "") {
            navigate(mainType === "Retail" ? "/retail-home" : "/hni-home");
        } else {
            ClientDetails();
        }
        return () => {
            let keysToRemove = ["ekycId", "name", "mobile", "panNo"];
            for (let key of keysToRemove) {
                localStorage.removeItem(key);
            }
        };
    }, []);

    const ClientDetails = async () => {
        try {
            const encResponse = await axiosInstance.post(
                `${URL}`,
                AESEncryption({
                    mobile: localStorage.getItem("mobile") || "",
                    panNo: localStorage.getItem("panNo"),
                    name: localStorage.getItem("ClientName"),
                }),
            );
            let response = ApiResDecrypt(encResponse.data);

            const data = await response;
            if (data !== "" || data !== null) {
                setClientData(data.data);
                localStorage.setItem("ekycId", data.data.ekycId);
                localStorage.setItem("name", data.data.name);
            } else {
                console.log("error");
            }
        } catch (err) {}
    };

    return (
        <>
            <div className="card-box bottom-25">
                <div className="card-title">Client Details</div>
                <div className="client-details-oms-wrapper">
                    <ul className="client-details-oms-top row">
                        <li className="col-md-3">
                            <span className="text-content">EKYC-Id:</span>
                            <span className="text-content">{clientData?.ekycId ? clientData?.ekycId : "N.A"}</span>
                        </li>
                        <li className="col-md-4">
                            <span className="text-content">Client-Name:</span>
                            <span className="text-content">{clientData?.name ? clientData?.name : "N.A"}</span>
                        </li>
                        <li className="col-md-4">
                            <span className="text-content">Mobile:</span>
                            <span className="text-content">{clientData?.mobile ? clientData?.mobile : "N.A"}</span>
                        </li>
                    </ul>
                    <ul className="client-details-oms-bottom row">
                        <li className="col-md-3">
                            <span className="text-content">Pan No:</span>
                            <span className="text-content">{clientData?.panNo ? clientData?.panNo : "N.A"}</span>
                        </li>
                        <li className="col-md-4">
                            <span className="text-content">Date of Latest Objection:</span>
                            <span className="text-content">
                                {clientData?.lastUpdated?.split("T")[0]
                                    ? clientData?.lastUpdated?.split("T")[0]
                                    : "N.A"}
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}

export default ClientDetailsOmsComp;
